import listActions from 'src/modules/temaComunicacion/list/temaComunicacionListActions';
import TemaComunicacionService from 'src/modules/temaComunicacion/temaComunicacionService';
import Errors from 'src/modules/shared/error/errors';
import { i18n } from 'src/i18n';
import { getHistory } from 'src/modules/history';
import Message from 'src/view/shared/message';

const prefix = 'TEMACOMUNICACION_DESTROY';

const temaComunicacionDestroyActions = {
  DESTROY_STARTED: `${prefix}_DESTROY_STARTED`,
  DESTROY_SUCCESS: `${prefix}_DESTROY_SUCCESS`,
  DESTROY_ERROR: `${prefix}_DESTROY_ERROR`,

  DESTROY_ALL_STARTED: `${prefix}_DESTROY_ALL_STARTED`,
  DESTROY_ALL_SUCCESS: `${prefix}_DESTROY_ALL_SUCCESS`,
  DESTROY_ALL_ERROR: `${prefix}_DESTROY_ALL_ERROR`,

  doDestroy: (id) => async (dispatch) => {
    try {
      dispatch({
        type: temaComunicacionDestroyActions.DESTROY_STARTED,
      });

      await TemaComunicacionService.destroyAll([id]);

      dispatch({
        type: temaComunicacionDestroyActions.DESTROY_SUCCESS,
      });

      Message.success(
        i18n('entities.temaComunicacion.destroy.success'),
      );

      dispatch(listActions.doFetchCurrentFilter());

      getHistory().push('/tema-comunicacion');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: temaComunicacionDestroyActions.DESTROY_ERROR,
      });
    }
  },

  doDestroyAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type: temaComunicacionDestroyActions.DESTROY_ALL_STARTED,
      });

      await TemaComunicacionService.destroyAll(ids);

      dispatch({
        type: temaComunicacionDestroyActions.DESTROY_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doClearAllSelected());
        dispatch(listActions.doFetchCurrentFilter());
      }

      Message.success(
        i18n('entities.temaComunicacion.destroyAll.success'),
      );

      getHistory().push('/tema-comunicacion');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: temaComunicacionDestroyActions.DESTROY_ALL_ERROR,
      });
    }
  },
};

export default temaComunicacionDestroyActions;
